import attributeKeys from "../../hooks/api/attributes/attributeKeys";

/**
 * Add new attributes to the attribute cache store
 * @param {Object} params
 * @param {QueryClient} params.queryClient - query client object
 * @param {Object} params.removedItems - new attributes
 */
const removeAttributesFromStore = ({ queryClient, removedItems = [] }) => {
  const queryKey = attributeKeys.attributes;

  const attributesCache = queryClient.getQueryData(queryKey);

  const newAttributes = attributesCache?.filter(
    (item) => !removedItems?.includes(item.id)
  );
  queryClient.setQueryData(queryKey, newAttributes);
};

export default removeAttributesFromStore;
